import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { msalConfig } from './auth/msalConfig'
import App from './App'
import { SearchProvider } from './context/SearchProvider'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/theme.css'
import './index.css'

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {

  // Handle redirect FIRST before anything else
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        // Came back from Azure redirect — set the account
        msalInstance.setActiveAccount(response.account)
      } else {
        // No redirect response — check if already logged in
        const accounts = msalInstance.getAllAccounts()
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0])
        }
      }
    })
    .catch((error) => {
      console.error('Redirect error:', error)
      // Clear any stuck state and reload
      msalInstance.clearCache()
    })

  // Listen for login success events
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account)
    }
  })

  ReactDOM.createRoot(document.getElementById('root')).render(
    <MsalProvider instance={msalInstance}>
      <SearchProvider>
        <App />
      </SearchProvider>
    </MsalProvider>
  )
})
